import React, { useState } from 'react';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import ExpandMore from '@material-ui/icons/ExpandMore';
import CardContent from '@material-ui/core/CardContent';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';

import './CardData.scss';

interface CardDataProps {
	children?: React.ReactNode;
	innerRef?: React.Ref<HTMLDivElement>;
	box?: boolean;
	className?: string;
	title?: string;
	activeBorder?: boolean;
	noPadding?: boolean;
}

const CardData = (props: CardDataProps) => {
	const { children, innerRef, box, className, title, activeBorder, noPadding, ...rest } = props;
	const [expanded, setExpanded] = useState(!!children);
	const toggleCardContent = () => {
		setExpanded((prevState) => !prevState);
	};

	return (
		<Card
			variant="outlined"
			{...rest}
			ref={innerRef}
			className={[
				'cardData__container',
				className,
				!!box ? 'cardData__container--box' : '',
				activeBorder ? 'activeBorder' : '',
				noPadding ? 'noPadding' : '',
			]
				.join(' ')
				.trim()}
		>
			{title && (
				<>
					<CardActions onClick={toggleCardContent}>
						{title}
						{expanded ? <ExpandLess /> : <ExpandMore />}
					</CardActions>
					<Collapse in={expanded} timeout="auto" unmountOnExit>
						<CardContent>{children}</CardContent>
					</Collapse>
				</>
			)}

			{!title && <CardContent>{children}</CardContent>}
		</Card>
	);
};

export default CardData;
